import React from "react";
import CustomDialogComponent from "./customDialog.component";

export default function CustomDialogContainer({ isOpen, handleClose, maxWidth, ...props }) {
  return (
    <CustomDialogComponent isOpen={isOpen} handleClose={handleClose} maxWidth={maxWidth} {...props} />
  );
}
